import AppProvidersWrapper from './components/wrappers/AppProvidersWrapper'
import AppRouter from './routes/router'
import '@/assets/scss/style.scss'
import configureFakeBackend from './helpers/fake-backend'

// To use the REAL backend:
// 1. Make sure the backend server is running (e.g., `npm run dev:backend`).
// 2. Keep the line below commented out.

// To use the FAKE backend for local testing:
// 1. Uncomment the line below.
// 2. The app will now use mock data without needing the real backend.
configureFakeBackend()

function App() {
  return (
    <AppProvidersWrapper>
      <AppRouter />
    </AppProvidersWrapper>
  )
}
export default App
